import { Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";

export const GetInTouchScreen = () => {
  const { t } = useTranslation("onboarding", {
    keyPrefix: "GET_IN_TOUCH_SCREEN",
  });
  return (
    <Text textAlign={"center"} color={"text.mid"}>
      {t("DESCRIPTION")}
    </Text>
  );
};
